var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCeregoCurve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "35px",
    viewBox: "0 0 100 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "COLOR_RGB",
    transform: "translate(0.000000, -2.000000)",
    fill: "#7DCC31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.096,36.509 C60.892,36.509 55.903,28.297 51.501,20.827 C48.559,15.833 45.225,10.173 42.309,10.173 C39.178,10.173 36.95,16.107 34.983,21.343 C32.638,27.59 30.213,34.05 24.713,34.05 C19.078,34.05 16.975,27.377 14.619,20.975 C12.839,16.139 10.73,10.499 7.495,10.173 C3.869,9.809 2.214,13.665 2.204,13.714 L0,8.439 C1.806,5.73 4.949,4.612 7.495,4.612 C14.168,4.612 16.742,12.157 19.243,18.952 C20.535,22.461 22.615,28.489 24.713,28.489 C26.661,28.489 28.499,22.792 29.777,19.388 C32.378,12.462 35.325,4.612 42.309,4.612 C48.403,4.612 52.235,11.117 56.293,18.003 C60.117,24.493 64.07,31.204 69.096,31.204 C76.419,31.204 88.461,17.555 96.312,1.949 L99.925,10.715 C96.601,15.845 82.751,36.509 69.096,36.509",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeregoCurve);
export default __webpack_public_path__ + "static/media/cerego-curve.12d86dedc8bc90dac8e350456bce9e06.svg";
export { ForwardRef as ReactComponent };